<template>
  <div>
    <div v-if="!reportMode">
      <div class="table-toolbar d-print-none" style="float:right;height:0px;overflow:hidden;"></div>
      <div class="d-flex justify-content-end">
        <b-button v-if="filter.mode=='INDICATORS'" variant="default" @click="rollingButtonClick()">
          <img v-if="! filter.rolling" title="Visualizza misure" src="/static/icons/rolling.svg" width="16">
          <img v-if="filter.rolling" title="Visualizza misure" src="/static/icons/rolling-disable.svg" width="16">
        </b-button>
      </div>
      <b-button-toolbar>
        <b-button-group class="mx-1">
          <b-button variant="default" @click="close()">
            <font-awesome-icon icon="times" style="color:black" />
          </b-button>
          <b-button v-if="filter.sampling == 'm'" variant="default" @click="switchColumns()">
            <font-awesome-icon v-if="! filter.tableModeInverted" icon="turn-down" style="color:black" />
            <font-awesome-icon v-else icon="turn-up" style="color:black" />
          </b-button>
          <b-dropdown class="download_dropdown">
            <template #button-content>
              <font-awesome-icon style="color:black" icon="bars" />
            </template>
            <b-dropdown-item>
              <span @click="downloadTable('xlsx', 'data-table')">
                Download Excel
              </span>
            </b-dropdown-item>
            <b-dropdown-item>
              <span @click="downloadTable('csv', 'data-table')">
                Download CSV
              </span>
            </b-dropdown-item>
          </b-dropdown>
        </b-button-group>
      </b-button-toolbar>
    </div>
    <section :class="{ reportMode, indicators: filter.mode == 'INDICATORS', measures: filter.mode != 'INDICATORS' }" class="mb-5 chart-line-table-section" style="height:100%; overflow:scroll">
      <div>
        <table id="data-table" class="table b-table data table-striped table-hover" :class="filter.tableModeInverted ? '' : 'chart-line-table '">
          <thead v-if="isComparing && ! filter.tableModeInverted">
            <tr>
              <th style="width: 100px"></th>
              <th style="width: 80px" v-if="hasHourField"></th>
              <th class="text-center" v-for="field, idx in channelHeaders" :colspan="field.span" :key="idx">{{ field.name }}</th>
            </tr>
          </thead>
          <thead>
            <tr v-if="! filter.tableModeInverted">
              <th style="width: 100px">{{ date_field }}</th>
              <th style="width: 80px" v-if="hasHourField">Ora</th>
              <th v-for="field, idx in table_fields" :key="idx">{{ field.name }}</th>
            </tr>
            <tr v-else>
              <th v-for="col, monthIdx in table_items.date" :key="monthIdx" class="date-cell">{{ col }}</th>
            </tr>
          </thead>
          <tbody v-if="! filter.tableModeInverted">
            <tr v-for="item, rowIdx in table_items" :key="rowIdx">
              <td class="date-cell" data-t="d" :data-v="item.dateValue">{{ item.date }}</td>
              <td v-if="hasHourField">{{ item.hour }}</td>
              <td v-for="v, idx in item.values" :key="idx" data-t="n" :data-v="v.dataValue" class="data-cell" :class="v.style" v-html="v.fmtValue">
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr v-for="row, rowIdx in table_items.values" :key="rowIdx" class="data-cell">
              <td v-for="val, valIdx in row" :key="valIdx" data-t="n" :data-v="val.dataValue" :class="val.style" v-html="val.fmtValue"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import moment from 'moment';
import utils from '../../utilsMixin';

export default {
  name: "ChartTable",
  props: ['series', 'filter', 'id', 'dates', 'reportMode', 'chart', 'maxMonth', 'propSwitchColumns'],
  mixins: [utils],
  data() {
    return {
      items: [],
      fields:[],
      table_fields: [],
      channelHeaders:[],
      table_items: [],
      copy_table_items: [],
      dateFormat: {
        m: "MM/YYYY",
        w: "DD/MM/YYYY",
        d: "DD/MM/YYYY",
        "60": "DD/MM/YYYY"
      },
      minutesSampling: ['1', '15', '60'],
      perPage: 100,
      isComparing: false,
      isComparingYear: false,
      date_field: "",
      periodSpanLength: 0
    }
  },

  watch: {
    maxMonth() {
      this.refresh();
    },
    series() {
      this.refresh();
    }
  },

  created() {
    moment.locale('it');
    this.refresh();
  },

  mounted() {
    this.infiniteScroller();
    if(this.propSwitchColumns) {
      this.switchColumns();
    }
  },

  methods: {
    totalIndicator(index) {
      const maxRows = this.periodSpanLength
      const num = this.series[index].meta.numerators.reduce((a, b, i) => {        
        if (i < maxRows)
          return (a == null ? 0 : a) + (b == null ? 0 : b)
        return a
      }, 0)
      const den = this.series[index].meta.denominators.reduce((a, b, i) => {
        if (i < maxRows)
          return (a == null ? 0 : a) + (b == null ? 0 : b)
        return a
      }, 0)
      return den == 0 ? 0 : num / den
      
    },
    switchColumns() {
      if(this.filter.tableModeInverted) {
        this.table_items = [...this.copy_table_items];        
      } else {
        this.table_items = [];
        let columns = ["Valore"];
        let values = this.copy_table_items[0].values.map(v => []);
        values = values.map(v => {
          v = ["", ...v];
          return v;
        })

        this.copy_table_items.forEach((item, index) => {
            columns.push(item.date);

          item.values.forEach((val, idx) => {
            values[idx].push(val);
          })
        })

        if(! this.isComparing) {
          for(let i = 0; i < values.length; i++) {
            values[i][0] = { fmtValue: this.table_fields[i].name };            
          }
        } else {
          let storeIndex = 0;
          for(let i = 0; i < values.length; i++) {
            values[i][0] = { fmtValue: "" };
            if(this.channelHeaders[storeIndex]) {
              values[i][0].fmtValue = this.channelHeaders[storeIndex].name + " " + this.table_fields[i].name;
            } else {              
              values[i][0].fmtValue = this.table_fields[i].name;
            }
            if(values[i][0].fmtValue.includes("Scostamento")) {
              storeIndex++;
            }
          }
        }
        this.table_items = { date: columns, values: values };
      }

      this.filter.tableModeInverted = ! this.filter.tableModeInverted;
    },
    rollingButtonClick(){
      this.$emit("toggleRolling");
    },
    refresh() {
      if (this.series.length === 0) {
        return;
      }

      this.isComparingYear = this.filter.compare == "year";
      this.table_items = [];
      this.table_fields = [];
      this.isComparing = this.filter.compare != "no";
      this.date_field = this.filter.sampling == "m" ? "Mese" : "Data";

      const channelsCount = this.isComparing? (this.series.length/2):this.series.length;

      this.items = []
      this.dates.currentPeriodDates.forEach((date, rowIdx) => {
        let fmtDate = date;
        if(this.filter.sampling == "m") {
          fmtDate = moment(date).format('MMM YY');          
          if (this.maxMonth && this.maxMonth.isBefore(moment(date))) {            
            return;
          }
          this.periodSpanLength++
          if(this.isComparing) {
            if(this.isComparingYear) {
              fmtDate = moment(date).format('MMM');
            } else {
              fmtDate = moment(this.dates.previousPeriodDates[rowIdx]).format('MMM YY')
                + " - " + moment(date).format('MMM YY') 
                        
            }
          }
        } else {
          fmtDate = moment(date).format('DD/MM/yyyy');
          if(this.isComparing) {
            if(this.isComparingYear) {
              fmtDate = moment(date).format('D MMM');
            } else {
              fmtDate = moment(this.dates.previousPeriodDates[rowIdx]).format('D/MM/yyyy')
                + " - " + moment(date).format('D/MM/yyyy')
                        
            }
          }
        }
        const values = [];

        for(let i = 0; i<channelsCount; i++) {
          if(this.isComparing) {
            let current = this.series[i + channelsCount].data[rowIdx];
            let previous = this.series[i].data[rowIdx];

            if(this.filter.sampling == 'm' && this.reportMode) {
              const currentMoment = moment(this.dates.currentPeriodDates[rowIdx]).add(1, 'months');
              if(currentMoment.isAfter(moment())) {
                current = 0;
              }

              const previousMoment = moment(this.dates.previousPeriodDates[rowIdx]).add(1, 'months');
              if(previousMoment.isAfter(moment()))
                previous = 0;
            }
            let delta = 0;
            if(this.filter.mode == 'INDICATORS') {
              delta = this.calcDeltaPerc(current, previous, this.filter.mode.toLowerCase());
            } else {
              delta = this.calcDeltaPerc(current, previous, this.filter.sources[i].sourceType.toLowerCase());
            }

            //if(this.filter.compare == "year") {
              values.push({ value: previous, dataValue: this.formatPrecision(previous, 4, true) });
              values.push({ value: current, dataValue: this.formatPrecision(current, 4, true) });
            /*} else {
              values.push({ value: current, dataValue: this.formatPrecision(current, 4, true) });
              values.push({ value: previous, dataValue: this.formatPrecision(previous, 4, true) });
            }*/

            values.push({
              dataValue: delta.value ? this.formatPrecision(delta.value / 100, 4, true) : null,
              fmtValue: delta.label,
              style: 'delta-cell'
            });
          } else {
            if( isNaN(this.series[i].data[rowIdx]) ) {
              this.series[i].data[rowIdx] = null;
            }
            //if(this.series[i].data[rowIdx]) {
              values.push({
                fmtValue: this.formatPrecision(this.series[i].data[rowIdx], 4),
                dataValue: this.formatPrecision(this.series[i].data[rowIdx], 4, true),
              });
            //} else {
            //  values.push({ fmtValue: null });
            //}
          }
        }

        let hour = null;
        if(this.hasHourField) {
          hour = moment(date).format("HH:mm");
        }
        this.table_items.push({
          date: fmtDate,
          dateValue: moment(date).format("yyyy-MM-DD"),
          hour,
          values: values.map(v => {
            if(! isNaN(v.value)) {
              v.fmtValue = this.formatPrecision(v.value, 4)
            }
            return v;
          })
        });
      });

      // TOTAL ROWS
      //TODO this for loop is cumbersome, simplify!
      const values = [];

      for (let i = 0; i < channelsCount; i++) {
        if (this.filter.compare == "year") {
          if (this.filter.mode != 'INDICATORS') {
            values.push({
              value: this.series[i].data.filter((item, i) => {
                if (this.maxMonth && i > this.maxMonth.month()) {
                  return false;
                }
                return true;
              }).reduce((a, b) => (a || 0) + (b || 0))
            });
            values.push({
              value: this.series[i + channelsCount].data.filter((item, i) => {
                if (this.maxMonth && i > this.maxMonth.month()) {
                  return false;
                }
                return true;
              }).reduce((a, b) => (a || 0) + (b || 0))
            });
          } else {            
            values.push({ value: this.totalIndicator(i) })
            values.push({ value: this.totalIndicator(i + channelsCount) })
          }
        } else {
          if (this.filter.mode != 'INDICATORS') {
            values.push({ value: this.series[i].data.reduce((a, b) => (a || 0) + (b || 0)) });
          } else {
            values.push({ value: this.totalIndicator(i) })
          }
          if (this.isComparing) {
            if (this.filter.mode != 'INDICATORS') {
              values.push({
                value:
                  this.series[i + channelsCount].data.reduce((a, b) => a + b)
              });
            } else {
              values.push({
                value: this.totalIndicator(i + channelsCount)
              });
            }
          }
        }
        if (this.isComparing) {
          let delta = 0
          if (this.filter.mode == 'INDICATORS') {
            delta = this.calcDeltaPerc(this.totalIndicator(i + channelsCount), this.totalIndicator(i), this.filter.mode.toLowerCase());
          } else {
            const prev = this.series[i + channelsCount].data.filter((item, i) => {
              if (this.maxMonth && i > this.maxMonth.month()) {
                return false;
              }
              return true;
            }).reduce((a, b) => (a || 0) + (b || 0))
            const curr = this.series[i].data.filter((item, i) => {
              if (this.maxMonth && i > this.maxMonth.month()) {
                return false;
              }
              return true;
            }).reduce((a, b) => (a || 0) + (b || 0))

            delta = this.calcDeltaPerc(prev, curr, this.filter.sources[i].sourceType.toLowerCase());
          }
          values.push({ 
            dataValue: delta ? delta.value : '',
            fmtValue: delta ? delta.label : '',
            style: 'delta-cell'
           });
        }
      }

      if (this.filter.mode != 'INDICATORS') {
        this.table_items = [ { date: "Totale", values }, ...this.table_items];
        this.table_items.push({
          date: "Totale",
          values: values.map(v => {
            if(v.value && ! isNaN(v.value)) {
              v.fmtValue = this.formatPrecision(v.value, 4);
              v.dataValue = this.formatPrecision(v.value, 4, true);
            }
            return v;
          })
        });
      } else {
        this.table_items = [{ date: "Totale", values }, ...this.table_items];
        this.table_items.push({
          date: "Totale",
          values: values.map(v => {
            if (v.value && !isNaN(v.value)) {
              v.fmtValue = this.formatPrecision(v.value, 4);
              v.dataValue = this.formatPrecision(v.value, 4, true);
            }
            return v;
          })
        });        
      }

      /* TABLE FIELDS */
      for(let i=0; i<channelsCount; i++) {
        const s = this.series[i];
        let suffix = "";
        let prev_suffix = "";
        if(this.isComparing) {
          if(this.isComparingYear) {
            if(this.filter.sampling == "m") {
              suffix = parseInt(this.filter.fromMonth.split('-')[1]);
            } else {
              suffix = parseInt(this.filter.fromDate.split('-')[0]);
            }
          }

          if(this.isComparingYear) {
            prev_suffix = suffix - 1;
          }
        }
        this.channelHeaders.push({
          name:s.meta.cleanName,
          span: this.isComparing?3:1
        })
        if(!this.isComparing){
          this.table_fields.push({
            name: `${s.meta.cleanName} ${suffix} [${s.unit}]`,
          });
        }
        else{
          this.table_fields.push({
            name: `${prev_suffix} [${s.unit}]`,
          },
          {
            name: `${suffix} [${s.unit}]`,
          },
          {
            name: `Scostamento [%]`,
          });
        }
      }
      
      this.copy_table_items = [...this.table_items];
      this.filter.tableModeInverted = false;
    },

    calcDeltaPerc(current, previous, type) {
      if(current == null || previous == null) {
        return {
          value: null,
          label: null
        }
      }
      let diff = (current - previous) / previous * 100

      if (!Number.isFinite(diff)) {
        return this.f(current);
      }
      let label = "";

      if(type == 'parameter') {
        if (diff > 0) {
          label = `⬆ ${this.formatPrecision(diff, 4)}%`;
          label = label.fontcolor("green");
        }
        else {
          label = `⬇ ${this.formatPrecision(diff, 4)}%`;
          label = label.fontcolor("red");
        }
      } else {
        if (diff > 0) {
          label = `⬆ ${this.formatPrecision(diff, 4)}%`;
          label = label.fontcolor("red");
        }
        else {
          label = `⬇ ${this.formatPrecision(diff, 4)}%`;
          label = label.fontcolor("green");
        }
      }

      return {
        value: diff,
        label: label.replace(".", ",")
      }
    },

    close() {
      this.$emit('close');
    },
    f(v) {
      return v ? '' : '';
    },

    downloadTable(type, chart) {
      this.$emit('downloadTable', type, chart);
    },

    getInitialRowInfo(dateLine, previousDateline) {
      const momentDate = moment(dateLine);
      const previousMomentDate = previousDateline ? moment(previousDateline) : null;
      const previousFormattedDate = previousMomentDate ? previousMomentDate.format(this.dateFormat[this.filter.sampling]) : null;

      const item = {
        Data: `${this.filter.compare !== 'no' && previousFormattedDate ? `${previousFormattedDate} -` : ''}` + ' ' + momentDate.format(this.dateFormat[this.filter.sampling]),
      }
      if (this.minutesSampling.includes(this.filter.sampling)) {
        item.Ora = momentDate.format('HH:mm')
      }

      return item;
    },

    infiniteScroller() {
      window.onscroll = _.debounce(() => {
        let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;
        if (bottomOfWindow && (this.perPage < this.items.length)) {
          this.$store.commit("loading");
          this.perPage += 100;
          this.$store.commit("stopLoading");
        }
      },20);
    }
  },

  computed: {
    hasHourField() {
      return ['60', '15', '1'].indexOf(this.filter.sampling) >= 0
    }
  },
}
</script>

<style scoped>
table.data {
  font-size: 12px;
}

table.data td {
  padding-top: 6px;
  padding-bottom: 6px;
}

.red {
  color: red;
}
.green {
  color: green;
}
.measures .chart-line-table-section:not(.reportMode) .chart-line-table tbody tr:first-child,
.measures .chart-line-table-section:not(.reportMode) .chart-line-table tbody tr:last-child {
  background-color: #666;
  color: #fff;
  font-weight: bold;
}
.chart-line-table-section.reportMode .chart-line-table tbody tr:last-child {
  display: none;
}
.date-cell {
  text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// src/components/Charts/Table.vue